import mentoriaAxios from '../axiosTokenMiddleware';

const mentoriaFinancieraURL = process.env.REACT_APP_MENTORIA_FINANCIERA_URL;
const mentoriaFinancieraApiKey =
	process.env.REACT_APP_MENTORIA_FINANCIERA_API_KEY;

export const saveWaitingList = async () => {
	return mentoriaAxios.post(mentoriaFinancieraURL + "saveWaitingList", null, {
		headers: {
			"Content-Type": "application/json",
			ApiKey: mentoriaFinancieraApiKey,
		},
	});
};

export const saveDiscountCode = async (discountCode: string) => {
	return mentoriaAxios.post(mentoriaFinancieraURL + "saveDiscountCode", discountCode, 
	{
		headers: {
			"Content-Type": "application/json",
			ApiKey: mentoriaFinancieraApiKey,
		},
	});
};